import { fetchBeaconsStore, fetchBeaconStoreById, fetchBeaconsTypes, fetchBeaconTypeById, SearchBeaconsStores, updateBeacons } from "@/apiCalls/apiCalls";
import { useDebounce } from "@/utils/DebounceHook";
import { errorNotification, successNotification } from "@/utils/Notification";
import { Button, Col, Drawer, Input, Row, Select, Form, Spin } from "antd";
import { useEffect, useLayoutEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Beacons } from "./BeaconColumns";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import axios from "axios";
import SpinnerForm from "../spinnner/SpinnerForm";


const { Option } = Select
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface AssetDrawerProps {
    updateBeaconDrawer: boolean;
    setUpdateBeaconDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    beacons: Beacons
    getBeacons: any
    setBeaconsData: React.Dispatch<React.SetStateAction<Beacons | undefined>>;
}

const UpdateBeaconDrawer: React.FC<AssetDrawerProps> = ({ updateBeaconDrawer, setUpdateBeaconDrawer, beacons, getBeacons, setBeaconsData }) => {
    const onCLose = () => {
        setBeaconsData(undefined)
        setUpdateBeaconDrawer(false)
    }
    const [searchTermForBeacon, setSearchTermForBeacon] = useState('')
    const [BeaconStoresToDisplay, setBeaconsStoresToDisplay] = useState([])
    const [BeaconStoresToOptions, setBeaconStoresToOptions] = useState([])
    const [submitting, setSubmitting] = useState(false);
    const [searchTermForBeaconType, setSearchTermForBeaconType] = useState('')
    const [BeaconTypesToDisplay, setBeaconsTypesToDisplay] = useState([])
    const [BeaconTypesOptions, setBeaconTypesOptions] = useState([])
    const [loadingForm, setLoadingForm] = useState(true);
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()

    useEffect(() => {
        const setFormValues = async () => {
            const beaconStore: any = BeaconTypesToDisplay.find((c: any) => c.id === String(beacons.beacon_store_id)) ||
                await getSpecifiBeaconStoreById(beacons.beacon_store_id)
            const beaconTypes = BeaconTypesToDisplay.find((p: any) => p.id === String(beacons.beacon_type_id)) ||
                await getSpecifiBeaconTypeById(beacons.beacon_type_id);

            form.setFieldsValue({
                beacon_store_id: beaconStore ? { value: beaconStore.id, label: beaconStore.name } : undefined,
                beacon_type_id: beaconTypes ? { value: beaconTypes.id, label: beaconTypes.name } : undefined,
                id: beacons.id,
                cid: beacons.cid,
                tag_no: beacons.tag_no,
                config_status: beacons.config_status,
                install_status: beacons.install_status,
            })
            setLoadingForm(false)
        };
        if (beacons) {
            setFormValues()
        }
    }, [beacons, BeaconStoresToDisplay, BeaconTypesToDisplay, form])



    const getSpecifiBeaconStoreById = async (beaconStoreId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (beaconStoreId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/beaconStore/${beaconStoreId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : null

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return null
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(beaconStoreId)
        cleanup()
        return result2;
    }


    const getSpecifiBeaconTypeById = async (beaconTypeId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (beaconTypeId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/beaconTypes/${beaconTypeId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : null

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return null
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(beaconTypeId)
        cleanup()
        return result2;
    }


    const getBeaconsStores = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconStore', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setBeaconsStoresToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    useEffect(() => {
        getBeaconsStores()
    }, [])

    const getBeaconsTypes = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconTypes', {
            signal: controller.signal
        }).then((response: any) =>
            response.data.data
        ).then((data: any) => {
            if (isMounted) {
                setBeaconsTypesToDisplay(data)
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    useEffect(() => {
        getBeaconsTypes()
    }, [])



    const searchBeaconStoresBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beaconStore/search?query=${searchTermForBeacon}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setBeaconsStoresToDisplay(response.data.data);
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForBeacon, 500, searchBeaconStoresBySearchTerm)

    const searchBeaconTypesBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beaconTypes/search?query=${searchTermForBeaconType}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setBeaconsTypesToDisplay(response.data.data);
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForBeaconType, 500, searchBeaconTypesBySearchTerm)

    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }


    const onFinish = (beacons: any) => {
        setSubmitting(true)
        const extractedBeacons = {
            ...beacons,
            beacon_store_id: beacons.beacon_store_id?.value ? beacons.beacon_store_id.value : beacons.beacon_store_id,
            beacon_type_id: beacons.beacon_type_id?.value ? beacons.beacon_type_id.value : beacons.beacon_type_id,
        }
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/beacons/${extractedBeacons.id}`, extractedBeacons, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "beacon successfully updated",
                    `${beacons.id} updated `,
                    'topRight'
                )
            }
            getBeacons()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }

    const handleBeaconStoreChange = (value: any) => {
        setSearchTermForBeacon(value)
    }
    const handleBeaconTypeChange = (value: any) => {
        setSearchTermForBeaconType(value)
    }

    useEffect(() => {
        const updatedBeaconStoreOptions: any = BeaconStoresToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setBeaconStoresToOptions(updatedBeaconStoreOptions)
    }, [BeaconStoresToDisplay])

    useEffect(() => {
        const updatedBeaconTypesOptions: any = BeaconTypesToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setBeaconTypesOptions(updatedBeaconTypesOptions)
    }, [BeaconTypesToDisplay])

    const filterBeaconsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }

    const filterBeaconsTypesOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }
    return (
        <>
            <Drawer
                title="update  Beacon"
                width={720}
                onClose={onCLose}
                open={updateBeaconDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >

                {(loadingForm) ? (
                    <div>
                        <SpinnerForm />
                    </div>
                ) : (
                    < Form layout="vertical"
                        onFinishFailed={onFinishFailed}
                        onFinish={onFinish}
                        form={form}
                        initialValues={{
                            beacon_store_id: beacons.beacon_store_id,
                            beacon_type_id: beacons.beacon_type_id,
                            id: beacons.id,
                            cid: beacons.cid,
                            tag_no: beacons.tag_no,
                            config_status: beacons.config_status,
                            install_status: beacons.install_status,
                        }}
                        hideRequiredMark>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="beacon_store_id"
                                    label="beacon Store"
                                    rules={[{ required: true, message: 'Please slect product name' }]}
                                >
                                    <Select
                                        placeholder="Please select product name"
                                        showSearch
                                        style={{ borderColor: 'black' }}
                                        onSearch={handleBeaconStoreChange}
                                        filterOption={filterBeaconsOptions}
                                    >
                                        {BeaconStoresToOptions.map((option: any) => (
                                            <Option key={option.value} value={option.value}>{option.label}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    name="beacon_type_id"
                                    label="beacon type"
                                    rules={[{ required: true, message: 'Please slect beacon type' }]}
                                >
                                    <Select
                                        placeholder="Please select beacon type"
                                        showSearch
                                        style={{ borderColor: 'black' }}
                                        onSearch={handleBeaconTypeChange}
                                        filterOption={filterBeaconsTypesOptions}
                                    >
                                        {BeaconTypesOptions.map((option: any) => (
                                            <Option key={option.value} value={option.value}>{option.label}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="cid"
                                    label="cid"
                                    rules={[{ required: true, message: 'Please enter cid' }]}
                                >
                                    <Input
                                        placeholder="Please enter cid"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="tag_no"
                                    label="tag No"
                                    rules={[{ required: true, message: 'Please enter cid' }]}
                                >
                                    <Input
                                        placeholder="Please enter cid"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="id"
                                    label="id"
                                    hidden={true}
                                    rules={[{ required: true, message: 'Please enter beaconId' }]}
                                >
                                    <Input
                                        placeholder="Please enter beaconId"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="config_status"
                                    label="config  status"
                                    hidden={true}
                                    rules={[{ required: true, message: 'Please enter cid' }]}
                                >
                                    <Input
                                        placeholder="Please enter cid"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="install_status"
                                    label="install status"
                                    hidden={true}
                                    rules={[{ required: true, message: 'Please enter beaconId' }]}
                                >
                                    <Input
                                        placeholder="Please enter beaconId"
                                        className='focus:border-green-500 hover:border-green-500'
                                    />
                                </Form.Item>
                            </Col>

                        </Row>
                        <Row>
                            <Col span={12}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            {submitting && <Spin indicator={antIcon} />}
                        </Row>
                    </Form>
                )}
            </Drawer >
        </>
    )
}

export default UpdateBeaconDrawer